import script from "./TasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksList.vue?vue&type=script&setup=true&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=296ad0da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296ad0da"]])

export default __exports__